<template>
  <div class="Item">
    <div class="Item__icon">
      <Alpha class="Item__icon-item" v-if="props.iconName === 'alpha'" />
      <Signal class="Item__icon-item" v-else-if="props.iconName === 'signal'" />
      <Calendar class="Item__icon-item" v-else-if="props.iconName === 'calendar'" />
      <Podcasts class="Item__icon-item" v-else-if="props.iconName === 'podcasts'" />
      <Forecasters class="Item__icon-item" v-else-if="props.iconName === 'forecasters'" />
      <Chat class="Item__icon-item" v-else-if="props.iconName === 'chat'" />
      <Screener class="Item__icon-item" v-else-if="props.iconName === 'screener'" />
      <CrownGradientIcon class="Item__crown-icon" v-else-if="props.iconName === 'crown'" />
      <AvatarImage class="Item__img" :size="18" :src="PON_3" v-else-if="props.iconName === 'work'" />
      <AvatarImage class="Item__img" :size="18" :src="PON_2" v-else-if="props.iconName === 'meme'" />
      <AvatarImage class="Item__img" :size="18" :src="PON_4" v-else-if="props.iconName === 'alerts'" />
      <AvatarImage class="Item__img" :size="18" :src="PON_1" v-else-if="props.iconName === 'holders'" />
    </div>
    <p class="Item__ttl" :class="props.isLegendColor ? 'Item__ttl--legend' : ''">{{ props.title }}</p>
    <p class="Item__text">{{ props.text }}</p>
  </div>
</template>

<script setup>
  import { Props } from './props';
  //----------------------------------
  import Alpha from './icons/Alpha.vue';
  import Signal from './icons/Signal.vue';
  import Calendar from './icons/Calendar.vue';
  import Podcasts from './icons/Podcasts.vue';
  import Forecasters from './icons/Forecasters.vue';
  import Chat from './icons/Chat.vue';
  import Screener from './icons/Screener.vue';
  import CrownGradientIcon from '@shared/UI/SVG/CrownGradientIcon.vue';
  import AvatarImage from '@shared/UI/Images/AvatarImage/AvatarImage.vue';
  //----------------------------------
  const ICON_WORK = require('./icons/work.png');
  const ICON_MEME = require('./icons/meme.png');
  const ICON_ALERTS = require('./icons/alerts.png');

  const PON_1 = require('@/Shared/images/ponIcons/icon-ponchat1.png');
  const PON_2 = require('@/Shared/images/ponIcons/icon-ponchat2.png');
  const PON_3 = require('@/Shared/images/ponIcons/icon-ponchat3.png');
  const PON_4 = require('@/Shared/images/ponIcons/icon-ponchat4.png');
  //----------------------------------
  const props = defineProps(Props());
</script>

<style lang="scss" scoped>
  @import "./styles";
</style>